import axios from "axios";

const API_BASE = "https://dashboard.lono.co.in/api/invoices";

// Invoice APIs
export const getInvoices = async () => {
  const response = await axios.get(`${API_BASE}/getInvoices`);
  return response.data;
};

export const createInvoice = async (data) => {
    console.log("Creating invoice with data:", data);
  const response = await axios.post(`${API_BASE}/createInvoice`, data);
  return response.data;
};

export const updateInvoice = async (id, data) => {
  const response = await axios.put(`${API_BASE}/invoices/${id}`, data);
  return response.data;
};

export const deleteInvoice = async (id) => {
  const response = await axios.delete(`${API_BASE}/invoices/${id}`);
  return response.data;
};
